import { render, staticRenderFns } from "./WithdrawalPage.vue?vue&type=template&id=6c0e45b8&scoped=true&"
import script from "./WithdrawalPage.vue?vue&type=script&lang=js&"
export * from "./WithdrawalPage.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawalPage.vue?vue&type=style&index=0&id=6c0e45b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e45b8",
  null
  
)

export default component.exports